import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { ApiHeaderService } from '../../core/services/api-header.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  public isLoggedIn: boolean = false;
  public server = environment.APIEndpoint;
  public authType = 'Bearer'
  public urls: any = {
    getProfileImages: this.server + 'portal/profileAvatars/getAllProfileAvatars/v1',
    viewProfile: this.server + 'api/user/profile/v3/view',
    updateProfile: this.server + 'api/user/profile/v3/update',
    sendOTP: this.server + 'api/sec/v3/send/otp',
    verifyOTP: this.server + 'api/user/otp/v3/verify',
    getAllFaq: this.server + 'portal/faqs/v1?faqCategoryType=',
    getWriteToUsDetails : this.server + 'portal/unsec/writeToUs/getWriteToUsDetails/v1',
    createSecWriteToUs : this.server + 'app/writeToUs/create/v1',
    createUnSecWriteToUs : this.server + 'app/unsec/writeToUs/create/v1',
    // pastOrders: this.server + 'api/order/v1/transaction/history',
   // pastOrders: this.server + 'api/order/transaction/v2/history',
    pastOrders: this.server + 'api/kiosk/order/transaction/v1/search',
    updateFavourite:  this.server + 'api/order/favourite/v1/update',
    // orderDetails: this.server + 'api/order/v1/view?orderId=',
    orderDetails: this.server + 'api/kiosk/order/transaction/v1/view?orderId=',
    msrOrderDetails: this.server + 'api/user/msrcard/order/v1/details?orderId=',
    notifications: this.server + 'api/notification/get/v1/list',
    changePswd: this.server + 'api/user/password/v3/change',
    accountDeletion: this.server + 'api/user/account/v1/delete',
    preferences_terms: this.server + 'api/user/preferences/v1/update',
    savedBlogList: this.server + 'api/cms/blogs/customer/v1/list',
    pullToRefresh: this.server + 'api/user/reward/summary/v3/refresh'
  };
  public deviceMetaInfo = {
    "appVersion":"",
    "deviceCountry":"India",
    "deviceCity":"",
    "deviceId":localStorage.getItem("deviceId"),
    "deviceModel":"",
    "platform":"WEB",
    "deviceOSVersion":""};
  public secHeaderData = {
    'Authorization': 'Bearer ' + this.storageService.getAccessToken(),
    'Accept-Language': 'EN',
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo),
  };
  public unsecHeaderData = {
    'Accept-Language': 'EN',
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
  };
  constructor(private http: HttpClient,private commonFunction: CommonFunctions, private apiHeader: ApiHeaderService,private storageService:StorageService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  getProfileImages() {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.getProfileImages, { headers: secHeaders });
  }
  viewProfile() {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.viewProfile, { headers: secHeaders });
  }
  updateProfile(requestData) {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.updateProfile, requestData, { headers: secHeaders });
  }
  sendOTP(requestData) {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.sendOTP, requestData, { headers: secHeaders });
  }
  verifyOTP(requestData) {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.verifyOTP, requestData, { headers: secHeaders });
  }
  getAllFaq(data) {
    return this.http.get(this.urls.getAllFaq + data, { headers: this.unsecHeaderData });
  }
  getWriteToUsDetails() {
    return this.http.get(this.urls.getWriteToUsDetails, { headers: this.unsecHeaderData });
  }
  createSecWriteToUs(requestData) {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.createSecWriteToUs, requestData, { headers: secHeaders });
  }
  createUnSecWriteToUs(requestData) {
    return this.http.post(this.urls.createUnSecWriteToUs, requestData, { headers: this.unsecHeaderData });
  }
  //profile orders
  pastOrders(search,page, pageSize, type){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.pastOrders + '?searchKey='+ search + '&page=' + page + '&pageSize=' + pageSize + '&type=' + type, { headers: secHeaders });
  }
  updateFavourite(requestData){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.updateFavourite, requestData, { headers: secHeaders});
  }
  orderDetails(id){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.orderDetails + id, { headers: secHeaders });
  }
  viewMsrDetails(id){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.msrOrderDetails + id, { headers:secHeaders });
  }
  //profile Settings
  getNotifications(){
    let secHeaderData = {
      'Authorization': 'Bearer ' + this.storageService.getAccessToken(),
      'Accept-Language': 'EN',
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo),
    };
    return this.http.get(this.urls.notifications , { headers: secHeaderData });
  }
  changePassword(requestData){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.changePswd, requestData, { headers: secHeaders });
  }
  deleteAccount(){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.accountDeletion , { headers: secHeaders });
  }
  preferencesAndTerms(requestData){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.preferences_terms , requestData, { headers: secHeaders });
  }
  //saved articles
  getSavedBlogList(){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.savedBlogList , { headers: secHeaders });
  }
  getLatestRewardsData(){
   let secureHeaders = this.apiHeader.getSecureHeader();
   return this.http.get(this.urls.pullToRefresh , { headers: secureHeaders });
  }
}
